module.exports = __webpack_public_path__ + "static/img/gothambold.8c2845b.svg";